export const NON_SMOKER = 'NonSmoker';
export const SMOKER = 'Smoker';
export const UNI_SMOKER = 'UniSmoker';

export const MALE = 'MALE';
export const FEMALE = 'FEMALE';
export const UNISEX = 'Unisex';
export const NON_BINARY = 'NON BINARY';